import client from '@config/client'

const fetcher = url => client.get(url).then(res => res.data)

export default fetcher
